import * as viem from 'viem';
import TrustedMulticallForwarder from '../contracts/abis/TrustedMulticallForwarder.json';
import Multicall3 from '../contracts/abis/Multicall3_1.json';
export const multicallReads = (calls) => {
    const ret = viem.encodeFunctionData({
        abi: Multicall3.abi,
        functionName: 'aggregate3Value',
        args: [
            calls.map((call) => ({
                target: call.to,
                callData: call.data,
                value: call.value || 0,
                allowFailure: false,
            })),
        ],
    });
    let totalValue = BigInt(0);
    for (const call of calls) {
        totalValue += call.value || BigInt(0);
    }
    return {
        to: '0xa0266ee94bff06d8b07e7b672489f21d2e05636e',
        data: ret,
        value: BigInt(totalValue),
    };
};
export const multicallWrites = (calls, walletAddress) => {
    const multicallData = viem.encodeFunctionData({
        abi: TrustedMulticallForwarder.abi,
        functionName: 'aggregate3Value',
        args: [
            calls.map((c) => ({
                target: c.to,
                allowFailure: false,
                value: c.value || BigInt(0),
                callData: c.data,
            })),
        ],
    });
    let totalValue = BigInt(0);
    for (const call of calls) {
        totalValue += call.value || BigInt(0);
    }
    return {
        account: walletAddress,
        to: TrustedMulticallForwarder.address,
        data: multicallData,
        value: totalValue,
    };
};
